// Drawola Studio — shared bits for the built-in templates. Fork-only.
//
// THEME SAFETY: never hardcode a near-white stroke. Excalidraw's dark mode is
// a canvas-wide colour inversion, so a scene authored for light mode reads
// correctly in dark mode *as long as* it uses normal palette values. A stroke
// picked to disappear on white (e.g. `#fafafa`) would become a near-black
// stroke on the dark canvas and stand out exactly where it should not.
//
// Everything below is straight out of upstream's element palette
// (`packages/common/src/colors.ts`), which is what the colour picker offers.

import type { AppState } from "@excalidraw/excalidraw/types";

/** Element strokes. `INK` is upstream's default element stroke. */
export const STROKE = {
  INK: "#1e1e1e",
  /** Mid gray — stays a mid gray after the dark-mode inversion. */
  MUTED: "#868e96",
} as const;

/** Element fills (upstream shade index 1, the colour picker's default row). */
export const FILL = {
  TRANSPARENT: "transparent",
  BLUE: "#a5d8ff",
  GREEN: "#b2f2bb",
  YELLOW: "#ffec99",
  RED: "#ffc9c9",
  GRAY: "#e9ecef",
  GRAY_FAINT: "#f8f9fa",
} as const;

/**
 * Scene-level state stored alongside a template's elements.
 *
 * Kept deliberately tiny: `useMultiFileStore.switchTo()` only pushes
 * `elements` into the editor, so this is what the doc carries on disk and
 * what `generateThumbnail` renders the preview against — not a scroll/zoom
 * override for the live canvas.
 */
export const templateAppState = (): Partial<AppState> => ({
  viewBackgroundColor: "#ffffff",
});
